/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Pie } from '@ant-design/plots';
import { ChartCard } from './index';
import { CHART_AXIS, rampColor } from './chartPalette';
import styles from './DistributionDonut.less';

/**
 * DistributionDonut —— 环形分布图（中心显示选中层 + 图例即数据）
 * ------------------------------------------------------------------
 * 商家端两处是同一形态：
 *   · 经营概览 → 本周完课情况（未完课 / 完课1次 / 完课次数≥2）
 *   · 会员经营 → 最近 7 天完课情况（未训练 / 训练1次 / 训练次数≥2）
 * 中心默认显示**第一项**（与商家端一致，不是占比最大项），点击图例切换，
 * 图例同时就是数据本身（色点 + 名称 + 大数字），选中项下方一条蓝短线。
 *
 * @param data    [{ name, num, memberType? }]
 * @param colors  { [name]: '#hex' }，缺省用中性蓝
 * @param onSelect 点击图例（用于跳会员列表等）
 */
const DistributionDonut = (props) => {
  const {
    data = [],
    colors = {},
    height = 300,
    emptyText = '暂无数据',
    onSelect,
  } = props;
  const [active, setActive] = useState(null);

  const total = data.reduce((s, i) => s + (Number(i.num) || 0), 0);
  if (!total) {
    return <ChartCard height={height} empty emptyText={emptyText} />;
  }

  /* rampColor 自带越界保护（超出取最深），比直接 index 数组稳 */
  const colorOf = (name) => colors[name] || rampColor(1);
  const shown = data.find((i) => i.name === active) || data[0];
  const percent = `${Math.round(((Number(shown.num) || 0) / total) * 100)}%`;

  return (
    <>
      <ChartCard height={height}>
        <Pie
          angleField="num"
          colorField="name"
          data={data}
          radius={0.92}
          innerRadius={0.66}
          color={data.map((i) => colorOf(i.name))}
          label={false}
          legend={false}
          tooltip={{
            formatter: (d) => ({ name: d.name, value: `${d.num} 人` }),
          }}
          statistic={{
            title: {
              content: shown.name,
              style: { fontSize: '18px', fontWeight: '600', fill: CHART_AXIS.strongLabel },
            },
            content: {
              content: percent,
              style: { fontSize: '22px', fontWeight: '700', fill: CHART_AXIS.strongLabel },
            },
          }}
        />
      </ChartCard>

      <div className={styles.legendRow}>
        {data.map((i) => (
          <button
            key={i.name}
            type="button"
            className={`${styles.item} ${
              shown.name === i.name ? styles.active : ''
            }`}
            onClick={() => {
              setActive(i.name);
              if (onSelect) onSelect(i);
            }}
          >
            <span className={styles.head}>
              <i
                className={styles.dot}
                style={{ background: colorOf(i.name) }}
              />
              {i.name}
            </span>
            <span className={styles.num}>{i.num}</span>
          </button>
        ))}
      </div>
    </>
  );
};

export default DistributionDonut;
